/**
 * Орлогын Төрөл. Дансны хуулгын isPack-тай ижил:
 * ялгаатай данс 1-ээс олон, эсвэл invoiceItemCount > 1 бол Багц.
 * API/functions/admin/invoicePackType.js-тэй ижил дүрэм.
 */
export function invoiceIsPack(invoice) {
  const accounts = new Set();
  (invoice?.invoiceItems || []).forEach((item) => {
    const account = String(item?.accountNumber ?? "").trim();
    if (account) accounts.add(account);
  });
  return accounts.size > 1 || Number(invoice?.invoiceItemCount) > 1;
}

export function invoiceIncomeProductName(invoice) {
  const name = invoice?.invoiceItems?.[0]?.productType?.name;
  const text = String(name ?? "").trim();
  return text || null;
}
